import React from 'react';
import { Field } from 'redux-form';
import { FormControlLabel, Radio } from '@material-ui/core';
import InlineFormRadioGroup from '../../../Auth/Registration/components/InlineFormRadioGroup';
import { required } from '../../../../utils/validators';
import { FINALIZE_BUY_FEE_METHODS } from '../../../../constants';
import { StyledRadio } from './StyledRadio';

const FinalizeFeePaymentMethodPicker = ({ hasAch, hasFlooring, hasCreditCard, awardedUserId, creditCardNumbers = '' }) => {
  const achFlooringDisabled = !hasAch && !hasFlooring;
  return (
    <>
      <Field name="finalize_buy_fee_method" component={InlineFormRadioGroup} row validate={required}>
        <FormControlLabel
          style={{ marginLeft: '-7px' }}
          control={<StyledRadio />}
          value={FINALIZE_BUY_FEE_METHODS.ACH}
          label="Include in ACH/flooring"
          disabled={achFlooringDisabled}
        />
        {hasCreditCard && (
          <FormControlLabel
            control={<StyledRadio />}
            value={FINALIZE_BUY_FEE_METHODS.CREDIT_CARD}
            label={`Pay with credit card (****${creditCardNumbers})`}
            disabled={!hasCreditCard}
          />
        )}
      </Field>
      {achFlooringDisabled && (
        <a target="_blank" href={`/admin/customers/${awardedUserId}/docs`} rel="noopener noreferrer">
          View Docs
        </a>
      )}
    </>
  );
};

export default FinalizeFeePaymentMethodPicker;
